import React from 'react';
import JiraLogWork from '../components/JiraLogWork';

const JiraTimeTracking = () => {
  return (
    <div className="space-y-4">
      <div className="page-header">
        <h1 className="page-title">Jira Time Tracking</h1>
        <p className="page-subtitle">Manage worklogs, view team reports, and track time.</p>
      </div>

      <div className="panel">
        <JiraLogWork />
      </div>
    </div>
  );
};

export default JiraTimeTracking;
